module.exports = __webpack_public_path__ + "img/img1.84df51aa.jpg";